import { getSession } from '@/modules/auth/service'

export const getToken = async (): Promise<string | undefined> => {
  const { data: sessionData } = await getSession()
  return sessionData?.session?.access_token
}

export default async function getAuthorizationHeader(): Promise<
  Record<string, string>
> {
  const token = await getToken()
  if (!token) return {}

  return {
    Authorization: `Bearer ${token}`,
  }
}
